import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgFormTextAlignRight = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      fillRule="evenodd"
      d="M5 5h14v2H5V5Zm6 4h8v2h-8V9Zm8 8h-8v2h8v-2ZM5 13h14v2H5v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFormTextAlignRight;
